import React from "react";
import styled from "styled-components";
import {
  TrackSubtitle,
  TrackSubtitleContainer,
  TrackTitle,
} from "../sharedStyles";
import { useTranslation } from "react-i18next";
import InfoTooltip from "../../InfoTooltip/InfoTooltip";
import { IListingIssueDetails } from "../../../commonTypes";

const Root = styled.div``;

const InfoIconContainer = styled.div`
  display: flex;
  justify-items: center;
  align-items: center;
`;

const StyledInfoTooltip = styled(InfoTooltip)`
  margin-left: 4px;
`;

type Props = {
  title: string;
  issueDetails?: IListingIssueDetails;
};
const InstantBidTitle = ({ title, issueDetails }: Props) => {
  const { t } = useTranslation();
  return (
    <Root>
      <TrackTitle>{title}</TrackTitle>
      <TrackSubtitleContainer>
        <TrackSubtitle>
          <InfoIconContainer>
            {t("instant-purchase-title")}
            <StyledInfoTooltip
              text={t("instant-purchase-info")}
              placement="bottom"
            />
          </InfoIconContainer>
        </TrackSubtitle>
        <TrackSubtitle>
          {issueDetails &&
            `${issueDetails.issueNumber} of ${issueDetails.totalIssues}`}
        </TrackSubtitle>
      </TrackSubtitleContainer>
    </Root>
  );
};

export default InstantBidTitle;
